import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class UnsavedChangesService {
  private trackedForm: FormGroup | null = null;

  constructor() {}

  init(form: FormGroup | null) {
    this.trackedForm = form;
    window.addEventListener("beforeunload", this.beforeUnloadHandler);
  }

  destroy() {
    this.trackedForm = null;
    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
  }

  hasUnsavedChanges(): boolean {
    return !!this.trackedForm?.dirty;
  }

  private beforeUnloadHandler = (event: BeforeUnloadEvent) => {
    console.log("beforeunload event triggered", this.hasUnsavedChanges());
    if (this.hasUnsavedChanges()) {
      event.preventDefault();
      event.returnValue = ""; // Required for Chrome
    }
  };
}
